import type { KeyArgsFunction } from '@apollo/client/cache/inmemory/policies'
import { omit } from 'lodash'

const keyArgs: KeyArgsFunction = (params?: Pick<GetClientMiDocumentsQueryVariables, 'filters'> | null) => {
  return JSON.stringify(params && params.filters ? omit(params.filters, ['bookmark', 'page_size']) : {})
}

export default {
  keyArgs,
}
